export function tasks(api: ReturnType<typeof useAxios>) {
  const getAllTasks = async (data: any) =>
    await api.$get(
      `/task?limit=${data.limit}&page=${data.page}&sort=${data.sort}&dir=${data.dir}&search=${encodeURIComponent(data.search)}&status=${data.status}&assigned_only=${data.assigned_only ?? false}`,
    );
  const createTask = async (data: any) => await api.$post(`/task`, data);
  const deleteTask = async (id: any) => await api.$delete(`/task/${id}`);
  const getTask = async (id: any) => await api.$get(`/task/${id}`);
  const updateTask = async (id: any, data: any) => await api.$put(`/task/${id}`, data);
  const addComment = async (id: any, data: any) => await api.$post(`/task/${id}/comments`, data);
  const assignTask = async (data: any) => await api.$post(`/task/assign/`, data);
  const getTaskDetail = async (data: any) => await api.$post(`/task/check-task-assign/`, data);
  const updateTaskTitle = async (id: any, data: any) => await api.$put(`/task/update-title/${id}`, data);
  const updateTaskPriority = async (id: any, data: any) => await api.$put(`/task/update-priority/${id}`, data);
  const updateTaskStatus = async (id: any, data: any) => await api.$put(`/task/update-status/${id}`, data);
  const updateTaskDeadlineDate = async (id: any, data: any) => await api.$put(`/task/update-deadline-date/${id}`, data);
  const updateTaskDescription = async (id: any, data: any) => await api.$put(`/task/update-description/${id}`, data);

  return {
    getAllTasks,
    createTask,
    deleteTask,
    getTask,
    updateTask,
    addComment,
    assignTask,
    getTaskDetail,
    updateTaskTitle,
    updateTaskPriority,
    updateTaskStatus,
    updateTaskDeadlineDate,
    updateTaskDescription,
  };
}
